import styled from '@emotion/styled';
import vars from '@variables';
import {
  OrderedListAtom,
  UnorderedListAtom,
} from '@atoms/list-atoms/list-atoms';
import {
  H2Atom,
  H3Atom,
  HighlightAtom,
  HighlightAuthorAtom,
  PAtom,
} from '@atoms/text-atoms/text-atoms';
import StyledCallToActionBlock from '@blocks/call-to-action-block/call-to-action-block';
import { FlexibleLinkAtom } from '@atoms/link-atoms/link-atoms';

export const TwoColumnTextTitle = styled(H2Atom)<{ color?: string }>`
  color: ${({ color }) => color};
  width: 100%;
  @media (min-width: ${vars.breakPointTablet}) {
    width: 80%;
  }
`;

export const TwoColumnsTextContainer = styled.div<{
  backgroundColor?: string;
  colour?: string;
}>`
  color: ${({ colour }) => colour || 'inherit'};
  li::marker {
    color: ${({ colour }) => colour};
  }
  > ${H2Atom} {
    color: ${({ color }) => color};
  }

  position: relative;
  margin-top: ${vars.spacingL};
  padding-top: ${vars.spacingXxl};
  padding-bottom: ${vars.spacingXxl};
  display: flex;
  flex-direction: column;
  gap: ${vars.spacingM};

  ${PAtom},
  ${H2Atom},
  ${H3Atom},
  ${HighlightAtom},
  ${HighlightAuthorAtom},
  ${UnorderedListAtom},
  ${OrderedListAtom},
  img,
  span,
  blockquote {
    background-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ colour }) => colour};
  }

  @media (min-width: ${vars.breakPointSmallDesktop}) {
    width: 83.33%;
    margin: 0 auto;
  }

  ${PAtom} > ${FlexibleLinkAtom} {
    color: ${({ colour }) => colour};
  }
`;

export const BackgroundColor = styled.div<{ backgroundColor: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  background-color: ${({ backgroundColor }) => backgroundColor};

  &.hide-mobile {
    @media screen and (max-width: ${vars.breakPointTablet}) {
      display: none;
    }
  }

  &.hide-desktop {
    @media screen and (min-width: ${vars.breakPointTablet}) {
      display: none;
    }
  }
`;

export const BackgroundImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  width: 100vw;
  margin-left: calc(-50vw + 50%);

  &.desktop-only {
    display: none;
    @media screen and (min-width: ${vars.breakPointTablet}) {
      display: block;
    }
  }

  &.mobile-only {
    display: block;
    @media screen and (min-width: ${vars.breakPointTablet}) {
      display: none;
    }
  }

  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;

    img {
      object-fit: cover !important;
      width: 100% !important;
      height: 100% !important;
    }
  }
`;

export const GifOrSvgImage = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

export const TwoColumnsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;

  @media (min-width: ${vars.breakPointTablet}) {
    flex-direction: row;
    gap: ${vars.spacingM};
  }
`;

export const Column = styled.div`
  flex: 1;

  ${StyledCallToActionBlock} {
    .component-grid-structure > .call-to-action-block-content {
      grid-column: col1-start / col10-end;
    }
  }
`;
